import PropTypes from 'prop-types';
import {
	Box,
	FormControl,
	Select,
	MenuItem,
	Button,
	FormControlLabel,
	Switch,
} from '@mui/material';

import WorkQueueFiltersSkeleton from './Skeletons/WorkQueueFiltersSkeleton';

const filterLabels = [
	'All priorities',
	'All statuses',
	'All due dates',
	'Assigned To: Me',
];

const WorkQueueFilters = ({
	showCompleted,
	onShowCompletedChange,
	loading = false,
}) => {
	if (loading) {
		return <WorkQueueFiltersSkeleton />;
	}

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: '8px',
				flexWrap: 'wrap',
				px: '12px',
				py: '8px',
				backgroundColor: 'background.subtle',
				borderBottom: '0.5px solid',
				borderColor: 'border.light',
			}}
		>
			{filterLabels.map((label) => (
				<FormControl
					key={label}
					size='small'
					sx={{
						minWidth: '110px',
						'& .MuiOutlinedInput-root': {
							height: '28px',
							fontSize: '11px',
							backgroundColor: 'background.paper',
						},
					}}
				>
					<Select
						value='all'
						disabled
						SelectDisplayProps={{ 'aria-label': label }}
					>
						<MenuItem value='all'>{label}</MenuItem>
					</Select>
				</FormControl>
			))}

			<FormControlLabel
				control={
					<Switch
						size='small'
						checked={showCompleted}
						onChange={(event) => onShowCompletedChange(event.target.checked)}
						inputProps={{ 'aria-label': 'Show Completed' }}
					/>
				}
				label='Show Completed'
				labelPlacement='start'
				sx={{
					m: 0,
					gap: '5px',
					'& .MuiFormControlLabel-label': {
						fontSize: '11px',
						color: 'text.secondary',
					},
				}}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant='outlined'
				size='small'
				disabled
				sx={{
					height: '28px',
					fontSize: '11px',
					textTransform: 'none',
				}}
			>
				Reset filters
			</Button>
		</Box>
	);
};

WorkQueueFilters.propTypes = {
	showCompleted: PropTypes.bool.isRequired,
	onShowCompletedChange: PropTypes.func.isRequired,
	loading: PropTypes.bool,
};

export default WorkQueueFilters;
